<template>
  <span>
    <span @click="showModal">
      <slot></slot>
    </span>

    <b-modal v-model="modalView" size="lg" centered no-fade>
      <div slot="modal-header">{{$t('TEAM.EDIT.TITLE')}}</div>
      <div class="p-4 text-center" v-if="modalLoading">
        <img src="/img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('TEAM.EDIT.PROCESSING')}}</h5>
      </div>
      <div class="p-4" v-if="modalLoading === false">
        <form enctype="multipart/form-data">
          <div class="form-group row">
            <b-form-group :label="$t('TEAM.EDIT.INPUT_ADMIN')">
              <b-form-radio-group id="isAdmin" v-model="editIsAdmin" name="isAdmin">
                <b-form-radio value="0">{{ $t('NO')}}</b-form-radio>
                <b-form-radio value="1">{{ $t('YES')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div class="form-group row">
            <b-form-group :label="$t('TEAM.EDIT.INPUT_STATE')">
              <b-form-radio-group id="state" v-model="editState" name="state">
                <b-form-radio value="0">{{ $t('TEAM.ACTIVE')}}</b-form-radio>
                <b-form-radio value="1">{{ $t('TEAM.INACTIVE')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <div v-if="modalLoading === false">
          <b-btn @click="hideModal">{{ $t('CLOSE')}}</b-btn>
          <b-button
            variant="primary"
            class="btn-fill"
            v-if="editedData"
            @click="modalSubmit"
          >{{ $t('TEAM.EDIT.SUBMIT')}}</b-button>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<script>
export default {
  props: ["item", "index"],
  data() {
    return {
      itemIndex: this.index,
      details: this.item,
      modalView: false,
      modalLoading: false,
      editIsAdmin: 0,
      editState: 0,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    showModal() {
      this.modalView = true;
    },
    hideModal() {
      this.modalView = false;
      this.addEmail = "";
      this.addAdmin = 0;
      this.modalLoading = false;
    },
    modalSubmit: function() {
      let self = this;
      this.modalLoading = true;
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/team/edit/user`, {
          accountId: this.details.id,
          isAdmin: parseInt(this.editIsAdmin),
          state: parseInt(this.editState)
        })
        .then(function(response) {
          self.hideModal();
          self.$noty.info(self.$t("TEAM.EDIT.SUCCESS.UPDATED_USER"));
          self.$emit("updatedUser", {
            index: self.itemIndex,
            updatedInfo: response.data
          });
        })
        .catch(function(error) {
          self.modalLoading = false;
          self.$noty.error(self.$t(error.response.data));
        });
    }
  },
  computed: {
    editedData() {
      if(this.details.isAdmin != this.editIsAdmin)
      {
        return true;
      }
      if(this.details.state != this.editState)
      {
        return true;
      }
      return false;
    }
  },
  mounted: function() {
    this.editIsAdmin = this.details.isAdmin;
    this.editState = this.details.state;
  }
};
</script>
<style>
</style>